import * as styles from './Popup.module.scss';

import cn from 'classnames';
import Button from 'src/components/ui/Button/index'
import * as React from 'react';
import { CSSTransition } from 'react-transition-group';
import Portal,{ PortalSelectors } from 'src/components/ui/Portal/Portal'
import Loader from 'src/components/ui/Loader';

export type CommonProps = {
  open: boolean;
  onClose: (args?: any) => void;
  isFull?: boolean;
  children: React.ReactElement;
  classNameAnimation?: string;
  classNameOverflow?: string;
  classNameContainer?: string;
  classNameContent?: string;
  onAfterExit?: () => void;
} & React.HTMLProps<HTMLDivElement>;

const Popup: React.FC<CommonProps> = ({
  children,
  onClose,
  isFull,
  classNameOverflow,
  classNameContainer,
  classNameContent,
}) => {

  React.useEffect(() => {
    const KeyDown = (e: KeyboardEvent): void => {
      if (e.keyCode === 27) {
        onClose();
      }
    };

    window.addEventListener('keydown', KeyDown);

    return (): void => {
      window.removeEventListener('keydown', KeyDown);
    };
  }, [onClose]);

  return (
    <div className={cn(styles.popup, isFull && styles.popup_full)}>
      <div className={cn(styles.popup__overflow, classNameOverflow)} onClick={() => onClose()}>
        <Button className={styles.popup__close} />
      </div>
      <div className={cn(styles.popup__container, classNameContainer)} >
        <div className={cn(styles.popup__content, classNameContent)} >
          <React.Suspense fallback={<Loader />}>{React.cloneElement(children, { onClose })}</React.Suspense>
        </div>
      </div>
    </div>
  );
};

const PopupWrapper: React.FC<CommonProps> = ({
  classNameAnimation = 'animation-fade',
  children,
  onAfterExit,
  ...props
}) => {
  const { open } = props;
  const [isMounted] = React.useState(typeof document !== 'undefined');

  return isMounted ? (
    <Portal portalSelector={PortalSelectors.modal}>
      <CSSTransition unmountOnExit in={open} timeout={300} classNames={classNameAnimation} onExited={onAfterExit}>
        <Popup {...props}>{children}</Popup>
      </CSSTransition>
    </Portal>
  ) : null;
};

export default React.memo(PopupWrapper);
